// extracted by mini-css-extract-plugin
export default {"wrapper":"Lo-z","response":"Mo-z","error":"No-z","disabled":"Oo-z","buttons":"Po-z","feedbackQuestionSection":"Qo-z","yesNoWrapper":"Ro-z"};